import React from 'react';

import DashboardLayout from '../../../components/DashboardLayout/DashboardLayout';



const DashboardSettingScreen: React.FC = () => {



  return (
    <DashboardLayout>

    <p>dd</p>
    </DashboardLayout>
  );
};

export default DashboardSettingScreen;
